module.exports = __webpack_public_path__ + "img/benefit_05.96bbb80e.svg";